import React from 'react';
import { BookOpenIcon, MailIcon, MapPinIcon, NavigationIcon, PhoneIcon } from 'lucide-react';
import { WeekendSchedule } from '../components/WeekendSchedule';
import { ContactForm } from '../components/ContactForm';
import { contact, magazine } from '../data/event';
import { directionsUrl, embedUrl } from '../utils/maps';
export function Visit() {
  const fullAddress = `${contact.street}, ${contact.city}`;
  return <div data-id="element-380" data-mp="11d8r3mqfnpx9">
      <section className="border-b border-line bg-canvas" data-id="element-381" data-mp="11dier3o09kzs">
        <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8 lg:py-16" data-id="element-382" data-mp="16cl8hryjc4sg">
          <h1 className="font-display text-5xl font-bold uppercase text-navy" data-id="element-383" data-mp="1b3uzavvtle5x">Visit & Contact</h1>
          <p className="mt-3 max-w-2xl text-lg text-muted" data-id="element-384" data-mp="1g2y5ijnjdqfh">
            Everything you need to plan your Showcase weekend — and how to reach the CCCIA team.
          </p>
        </div>
      </section>

      <section className="mx-auto grid max-w-7xl gap-12 px-5 py-14 lg:grid-cols-12 lg:px-8" data-id="element-385" data-mp="1p3m7gfzno0c0">
        <div className="lg:col-span-5" data-id="element-386" data-mp="1p19qa51q1u00">
          <h2 className="font-display text-3xl font-bold uppercase text-ink" data-id="element-387" data-mp="2gozdaemt492q">Showcase schedule</h2>
          <div className="mt-6" data-id="element-388" data-mp="2cmvzvkgkuuet">
            <WeekendSchedule data-id="element-389" data-mp="2cludiju42lhs" />
          </div>

          <div className="mt-10 border-t border-line pt-8" data-id="element-390" data-mp="27nj4gbbn4f0m">
            <div className="flex items-start gap-3" data-id="element-391" data-mp="27q5c0ayj6uiu">
              <BookOpenIcon className="mt-1 h-5 w-5 shrink-0 text-orange-deep" aria-hidden="true" data-id="element-392" data-mp="22prazcvckkub" />
              <div data-id="element-393" data-mp="30czx9a369xxd">
                <h3 className="text-lg font-semibold text-ink" data-id="element-394" data-mp="30c6v6mf5rwlk">Pick up your magazine</h3>
                <p className="mt-1 text-muted" data-id="element-395" data-mp="2veyb2gag9iho">
                  Hard copies available at the CCCIA office starting {magazine.pickupDate}. Use it as your guide to every
                  home on the tour.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-396" data-mp="3j49fc7r0dv0k">
          <div className="overflow-hidden rounded-2xl border border-line" data-id="element-397" data-mp="3j5atil3bmxmi">
            <iframe title="Map to the CCCIA office" src={embedUrl(fullAddress)} className="h-72 w-full border-0" loading="lazy" data-id="element-398" data-mp="3eawtg5dps2bi" />
            <div className="grid gap-6 p-6 sm:grid-cols-2" data-id="element-399" data-mp="1gg13oa9f0ed4">
              <address className="not-italic" data-id="element-400" data-mp="12pnw490fr1ob">
                <p className="font-semibold text-ink" data-id="element-401" data-mp="12ow0iy6u93y1">{contact.org}</p>
                <p className="mt-2 flex gap-2 text-muted" data-id="element-402" data-mp="17n7b5b4yjihb">
                  <MapPinIcon className="mt-1 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-403" data-mp="sqyemhcgbj8l" />
                  <span data-id="element-404" data-mp="stb3zfkjgvvo">{contact.street}<br data-id="element-405" data-mp="xpt6s9wb6k5d" />{contact.city}</span>
                </p>
              </address>
              <div className="space-y-2" data-id="element-406" data-mp="jq9y9fzl56sj">
                <a href={contact.phoneHref} className="flex items-center gap-2 font-medium text-navy hover:text-orange-deep" data-id="element-407" data-mp="jrbl0hpyrhq3">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-408" data-mp="opmx6z3qe4bh" />
                  {contact.phone}
                </a>
                <a href={`mailto:${contact.email}`} className="flex items-center gap-2 font-medium text-navy hover:text-orange-deep" data-id="element-409" data-mp="2e2gnhipbdo3u">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-410" data-mp="2t6jemfz2abdt" />
                  {contact.email}
                </a>
                <a href={directionsUrl(fullAddress)} target="_blank" rel="noreferrer" className="flex items-center gap-2 font-medium text-navy hover:text-orange-deep" data-id="element-411" data-mp="2o9j4ntz3cohf">
                  <NavigationIcon className="h-4 w-4" aria-hidden="true" data-id="element-412" data-mp="3bxkc0zkj9yv9" />
                  Get directions
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-canvas py-16 lg:py-20" data-id="element-413" data-mp="3kz0m167fryyy">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-12 lg:px-8" data-id="element-414" data-mp="3kxpf4xip2b3m">
          <div className="lg:col-span-4" data-id="element-415" data-mp="3gxezsu90i8c3">
            <h2 className="font-display text-3xl font-bold uppercase text-ink" data-id="element-416" data-mp="1qkhf8rfv39b4">Send us a message</h2>
            <p className="mt-3 text-muted" data-id="element-417" data-mp="1mj5p8kt2sm2e">
              Questions about visiting, entering a model home, or sponsoring the Showcase? We’re happy to help.
            </p>
          </div>
          <div className="rounded-2xl bg-white p-6 sm:p-8 lg:col-span-8" data-id="element-418" data-mp="1o2e5zh3ci05m">
            <ContactForm data-id="element-419" data-mp="1sxbbie1f1rdr" />
          </div>
        </div>
      </section>
    </div>;
}